import { LayoutDashboard, FileText, Wallet, User, Earth } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { useIsLoggedIn } from '@ekonavi/base-test';
import { useResolveNavigate } from '../hooks/use-resolve-navigate';

export function MobileFooter() {
	const resolveNavigate = useResolveNavigate();
	const location = useLocation();
	const isLoggedIn = useIsLoggedIn();

	// Don't show mobile footer on public pages
	if (!isLoggedIn) {
		return null;
	}

	const tabs = [
		{ id: 'projects' as const, label: 'Projetos', icon: Earth, path: '/projetos' },
		{ id: 'reports' as const, label: 'Relatórios', icon: FileText, path: '/relatorios' },
		{ id: 'dashboard' as const, label: '', icon: null, path: '/painel' },
		{ id: 'wallet' as const, label: 'Carteira', icon: Wallet, path: '/carteira' },
		{ id: 'account' as const, label: 'Conta', icon: User, path: '/conta' },
	];

	const handleTabClick = (path: string) => {
		resolveNavigate({ path });
	};

	const currentPath = location.pathname;

	const isActive = (path: string) => {
		// Check for exact match or if current path starts with the tab path (for sub-routes)
		return currentPath === path || currentPath.startsWith(path + '/');
	};

	return (
		<div className='fixed z-[50] bottom-0 left-0 right-0 h-[var(--footer-height)]   border-t-[1px]  border-t-black/5 items-center justify-center flex w-full bg-[var(--background)]'>
			<div className={`border-t-[1px] border-t-white/30 w-full h-full flex items-center justify-center`}>
				<div className='max-w-6xl mx-auto w-full flex items-center justify-center h-full'>
					{tabs.map(({ id, label, icon: Icon, path }: any) => {
						const active = isActive(path);
						return (
							<button
								key={id}
								onClick={() => handleTabClick(path)}
								className={`flex flex-col items-center justify-center h-full flex-1 text-lg transition-colors cursor-pointer ${
									active ? 'text-orange-800' : 'text-muted-foreground'
								}`}>
								{Icon && (
									<Icon
										size={30}
										strokeWidth={2}
										className='mb-0.5'
									/>
								)}
								<span>{label}</span>
							</button>
						);
					})}
				</div>
			</div>
		</div>
	);
}
